// removed by extract-text-webpack-plugin
module.exports = {"root":"_tDXUO","inner":"_3Y2t6","header":"_17ZbG","title":"_1CNNp","body":"_3379C","footer":"_2IWFJ","ghost":"_2ptT1"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/AlertModalHandler/AlertModalHandler.scss
// module id = 788
// module chunks = 34